export default {
    handle(response) {
        if (response.toast) {
            const isSuccess = response.toast.type === "success";
            const options = {
                message: response.toast.message,
                position: "bottomRight",
                class: `app-toast app-toast--${isSuccess ? "success" : "error"}`,
                icon: isSuccess ? "bi bi-check-circle-fill" : "bi bi-exclamation-circle-fill",
                closeOnEscape: true,
                pauseOnHover: !isSuccess,
                timeout: isSuccess ? 3000 : 5000,
                transitionIn: "fadeInRight",
                transitionOut: "fadeOutRight",
            };
            isSuccess ? iziToast.success(options) : iziToast.error(options);
        }

        if (response.refresh) {
            $("[data-pjax-container]").each(function () {
                $.pjax.reload({ container: "#" + $(this).attr("id"), timeout: false });
            });
        }

        if (response.close_modals) $(".modal.show").modal("hide");
    },

    error(xhr) {
        this.handle({
            toast: { type: "error", message: xhr.responseJSON.message },
            refresh: 1,
        });
    },
};
